export const HTML_EDIT_MODAL_ID = `HTML.edit`;

export const HTML_BUTTONS = {
  alignment: 'HTML.alignment',
  edit: 'HTML.edit',
  width: 'HTML.width',
  height: 'HTML.height',
};
